import { PortalOffer } from '@portal/types/offer';
import { ButtonProps } from '@ag1/ui';
import { CustomContent, FieldOptionsWithRouter } from '../types';
import { useContentBlockField } from './useContentBlockField';
import { useContentBlockBackgroundColor } from './useContentBlockBackgroundColor';
import { useContentBlockImagePosition } from './useContentBlockImagePosition';
import { useOfferButtonDisabledReason } from '../../Offer/common';
import { useContentBlockToggle } from './useContentBlockToggle';
import { useContentBlockCaptions } from './useContentBlockCaptions';

export const useOfferContentBlock = (
  customContent: CustomContent[],
  { slug, router }: FieldOptionsWithRouter,
  offer: PortalOffer | null
) => {
  const headline = useContentBlockField(customContent, 'custom-headline', {
    slug,
    router,
    previewPlaceholder: 'Headline'
  });
  const backgroundColor = useContentBlockBackgroundColor(customContent, {
    slug,
    fallback: 'white'
  });
  const imagePosition = useContentBlockImagePosition(customContent, { slug, fallback: 'right' });
  const invalidReason = useOfferButtonDisabledReason(offer);
  let buttonLabel = useContentBlockField(customContent, 'button-label', {
    slug,
    router,
    previewPlaceholder: 'Get Your AG1'
  });
  const buttonIconPosition: ButtonProps['iconPosition'] = 'right';
  let buttonIcon: string | undefined;
  if (invalidReason) {
    buttonLabel = 'See Other Offers';
    buttonIcon = 'arrowRight';
  }

  const showTrumedNote = useContentBlockToggle(customContent, 'trumed-note', { slug });
  const captions = useContentBlockCaptions(customContent, { slug, router });
  const showOldPriceFirst = useContentBlockToggle(customContent, 'old-price-first', { slug });

  return {
    headline,
    backgroundColor,
    imagePosition,
    invalidReason,
    buttonLabel,
    buttonIcon,
    buttonIconPosition,
    showTrumedNote,
    showOldPriceFirst,
    captions
  };
};
